<template>
  <resource-edit-wrapper
    :title="$t('resources.ab_tests.edit_ab_test')"
    :need-modal="showModal"
    @saveAction="$refs['abTestForm'].submit()">
    <AbTestForm
      :abTest="item"
      @isDirtyForm="isDirtyForm"
      is-edit
      ref="abTestForm"
      @finishedSaving="finishedSaving"></AbTestForm>
    <template #actions>
      <v-btn
        v-if="item && $ability.can('update', 'ab_test')"
        @click="changeStatus"
        :loading="changeStatusLoading"
        outlined
        color="primary"
        class="cancel__btn">
        {{
          changeStatusValue !== AB_TEST_STATUSES.ACTIVE
            ? $t("resources.ab_tests.deactivate")
            : $t("resources.ab_tests.activate")
        }}
      </v-btn>
      <v-btn v-if="$ability.can('update', 'ab_test')" @click="save" :loading="saveLoading" color="primary">
        {{ $t("generic.buttons.save") }}
      </v-btn>
    </template>
  </resource-edit-wrapper>
</template>

<script>
  import ResourceEditWrapper from "@/components/resourceWrappers/ResourceEditWrapper";
  import AbTestForm from "@/components/forms/AbTestForm";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";
  import { AB_TEST_STATUSES } from "@/constant";
  import { formErrorMessage } from "@/utility/formErrorMessage";
  export default {
    components: {
      ResourceEditWrapper,
      AbTestForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        active: this.item?.active,
        saveLoading: false,
        changeStatusLoading: false,
        deleteLoading: false,
        AB_TEST_STATUSES,
        changeStatusValue: "",
      };
    },
    mounted() {
      this.changeStatusValue = this.updateChangeStatusValue(this.item.status);
    },
    methods: {
      updateChangeStatusValue(currentStatus) {
        const statusTransitions = {
          [AB_TEST_STATUSES.DRAFT]: AB_TEST_STATUSES.ACTIVE,
          [AB_TEST_STATUSES.ACTIVE]: AB_TEST_STATUSES.INACTIVE,
          [AB_TEST_STATUSES.INACTIVE]: AB_TEST_STATUSES.ACTIVE,
        };

        return statusTransitions[currentStatus] || null;
      },
      save() {
        this.saveLoading = true;
        this.showModal = false;

        this.$refs["abTestForm"].prepareBeforeSubmit(this.$refs["abTestForm"].form.status);
      },
      finishedSaving() {
        this.saveLoading = false;
        this.changeStatusLoading = false;
        this.deleteLoading = false;
      },
      async changeStatus() {
        try {
          this.changeStatusLoading = true;
          await this.$admin.dataProvider.customHttpCall("PATCH", `ab_tests/${this.item.id}`, {
            status: this.changeStatusValue,
          });
          if (this.changeStatusValue !== AB_TEST_STATUSES.ACTIVE) {
            this.$admin.toast.success(this.$t("resources.ab_tests.deactivate_success"));
          } else {
            this.$admin.toast.success(this.$t("resources.ab_tests.activate_success"));
            this.$refs["abTestForm"].callModalAfterSave();
          }

          this.changeStatusValue = this.updateChangeStatusValue(this.changeStatusValue);
          this.$refs["abTestForm"].form.status = this.updateChangeStatusValue(this.changeStatusValue);
        } catch (e) {
          this.$admin.toast.error(formErrorMessage(e, this.$t("generic.error")));
        } finally {
          this.changeStatusLoading = false;
        }
      },
    },
  };
</script>
